import React from 'react';

const MugIcon = () => {
  return (
    <svg width="56" height="54" viewBox="0 0 56 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 4.56C2 3.14615 3.14615 2 4.56 2H36.6145C38.0283 2 39.1745 3.14615 39.1745 4.56V40.4C39.1745 46.7624 34.0168 51.92 27.6545 51.92H13.52C7.15768 51.92 2 46.7624 2 40.4V4.56Z"
        stroke="#383838"
        strokeWidth="2.31325"
        strokeLinejoin="round"
      />
      <path
        d="M38.6433 42.9598C42.3199 40.3998 51.4977 41.5981 53.1999 33.3598C54.6409 26.3853 54.2212 17.5776 53.5131 14.2143C52.9541 11.5589 50.2205 8.37256 45.5471 8.37256C40.8737 8.37256 38.9974 8.37256 38.6433 8.37256"
        stroke="#383838"
        strokeWidth="2.31325"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MugIcon;
